/*eslint-disable */

import {bus} from '@/main';

export default {
  name: 'Resend-OTP-Popup',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    resendOTPLimitPopupClosed(){
      bus.$emit('resendOTPLimitStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    }
  }
}